import {AbstractGuard} from '../../../bonding_shared/components/abstract-guard';
import {Inject, Injectable} from '@angular/core';
import {LoggedUserService} from '../../../bonding_shared/services';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {CompanyElementaryRight} from '../../../bonding_shared/model/dictionary-ids';

@Injectable()
export class CompanyThirdPartyAccessGuard extends AbstractGuard {
  constructor(loggedUserService: LoggedUserService, router: Router) {
    super(loggedUserService, router);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkRight(state.url, CompanyElementaryRight.COMPANY_THIRD_PARTY_ACCESS);
  }
}
